import { Button } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext, useWatch } from '../../../../../../../../../../hooks/useForm'
import { useCreateOrEditAdditionalFieldModal } from '../../context/createOrEditAdditionalFieldModalContext'
import { CreateOrEditAdditionalFieldFormSchema } from '../../utils/formData'

export const ModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { submitForm, isLoading } = useCreateOrEditAdditionalFieldModal()
  const { control } = useFormContext<CreateOrEditAdditionalFieldFormSchema>()
  const priority = useWatch({ control, name: 'priority' })
  const name = useWatch({ control, name: 'name' })

  const isDisabled = priority === undefined || !name

  return (
    <Button type="button" onClick={submitForm} loading={isLoading} disabled={isDisabled}>
      {t('save')}
    </Button>
  )
}
